import { brandingImages } from '../../constants';

const getBrandingTriplet = (brands: string[]) => {
  return (
    <div className="flex justify-around w-1/2 my-2 h-20 sm:w-full sm:my-0">
      {brands.map((brand) => {
        return (
          <img
            className="w-1/4 object-scale-down py-4 sm:py-0 sm:object-contain"
            src={brand}
            key={brand}
            alt={'brand'}
          ></img>
        );
      })}
    </div>
  );
};

export const Branding = (): JSX.Element => {
  return (
    <div className="flex relative justify-center py-10 mt-28 flex-wrap border-sm border-grey-300 rounded-lg sm:pb-4 sm:border-0 sm:mt-4 sm:flex-col sm:justify-center sm:items-center">
      {getBrandingTriplet(brandingImages.slice(0, 3))}
      {getBrandingTriplet(brandingImages.slice(3))}
      <p className="absolute -bottom-3 text-s-18 bg-white px-4 right-4 sm:relative sm:text-center sm:text-base sm:w-full sm:right-0">
        trusted by your favourite brands
      </p>
    </div>
  );
};
